<template>
	<main class="vx-row">
		<div class="vx-col w-full">
			<vx-card>
				<vs-alert v-if="zakatCaption !== null" class="mt-4 mb-6">
					<h3><strong>{{ zakatCaption }}</strong></h3>
				</vs-alert>
				<form>
					<span class="text-danger text-sm my-6" v-show="errors.has('income')">{{ errors.first('income') }}</span>
					<p class="mb-2"><strong>Jumlah pendapatan per bulan (wajib diisi)</strong></p>
					<vs-input
					    v-model="income"
					    class="w-full mb-6"
					    size="large"
					    @keyup="toRupiah()"
					    v-validate="'required'"
					    dir="rtl"
					    name="income"
					/>

					<span class="text-danger text-sm my-6" v-show="errors.has('additional_income')">{{ errors.first('additional_income') }}</span>
					<p class="mb-2"><strong>Bonus, THR, dan lainnya (jika ada)</strong></p>
					<vs-input
					    v-model="additional_income"
					    @keyup="toRupiahAdd(additional_income)"
					    class="w-full mb-6"
					    size="large"
					    v-validate="'required'"
					    dir="rtl"
					    name="additional_income"
					/>
					<br>
					<vs-button
					    color="primary"
					    size="large"
					    class="w-full mb-4"
					    @click.prevent="calculateZakat"
					>
					Hitung Zakat
					</vs-button>
					<vs-button
					    color="warning"
					    size="large"
					    type="gradient"
					    class="w-full mb-4"
					    @click.prevent="payZakat"
					>
					<span class="text-dark">Bayar {{ capitalize(type) }}</span>
					</vs-button>
				</form>
			</vx-card>
		</div>
	</main>
</template>
<script>
// For custom error message
import { Validator } from 'vee-validate'
import { minNishabZakat } from '@/assets/utils/zakat'

const dict = {
	  custom: {
	    income: {
	      required: 'Harap masukan pendapatan'
	    },
	    additional_income:  {
	      required: 'Harap masukan pendapatan tambahan'
	    }
	  }
}

// register custom messages
Validator.localize('en', dict)
const nishabZakat = 6644868

export default {
  data: () => ({
    income: 0.0,
    type: 'zakat',
    additional_income: 0.0,
    zakat: 0,
    zakatCaption: null
  }),
  methods: {
    toRupiah () {
      this.income = this.formatRupiah(this.income)
    },
    toRupiahAdd () {
      this.additional_income = this.formatRupiah(this.additional_income)
    },
    calculateZakat () {
      this.$validator.validateAll().then(res => {
        if (res) {
          const income = this.income !== 0.0 ? parseInt(this.income.split('.').join('')) : parseInt(this.income),
            additional_income = this.additional_income !== 0.0 ? parseInt(this.additional_income.split('.').join('')) : parseInt(this.additional_income),
            jumlah = (income + additional_income)
          let total = parseFloat((income + additional_income) * minNishabZakat)

          if (isNaN(total)) {
            total = 0
          }

          this.zakat = Math.ceil(total)

          if (jumlah < nishabZakat) {
            this.zakatCaption = 'Anda belum wajib mengeluarkan zakat profesi'
            this.type = 'infaq'
          } else {
            this.type = 'zakat'
            this.zakatCaption = `Zakat Profesi Anda : Rp ${this.formatRupiah(this.zakat.toString())}`	
          }
						
        }
      })
    },
    payZakat () {
      this.$emit('payZakat', {total: this.zakat, type: this.type})
    }
  }
}
</script>